import { render, staticRenderFns } from "./insertChatRoomDialog.vue?vue&type=template&id=4e6d2144&scoped=true&"
import script from "./insertChatRoomDialog.vue?vue&type=script&lang=js&"
export * from "./insertChatRoomDialog.vue?vue&type=script&lang=js&"
import style0 from "./insertChatRoomDialog.vue?vue&type=style&index=0&id=4e6d2144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6d2144",
  null
  
)

export default component.exports